import React from 'react';

import { NonDeliveryDropdown } from './non-delivery-dropdown';

import messages from '../messages';
import { CustomsField } from '../customs-field';

export const CustomsNonDelivery = () => {
  return (
    <CustomsField label={messages.nonDeliveryLabel} recommended>
      <NonDeliveryDropdown />
    </CustomsField>
  );
};
